import { Stack } from "@mantine/core"
import { useDebouncedValue } from "@mantine/hooks"
import { useEffect, useState } from "react"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { HeaderControlsProvider } from "~/components/contexts/useHeaderControlsContext"
import { usePagination } from "~/components/hooks/usePagination"
import { ProductsLCATable } from "~/pages/Brand/Regulations/LCA/ProductsLCATable.tsx"
import { useFindProductLcas } from "~/gen/api"
const ProductsLCA = () => {
  const [searchProduct, setSearchProduct] = useState<string>()
  const [statusFilter, setStatusFilter] = useState<string | null>(null)

  const [debouncedProduct] = useDebouncedValue<string | undefined>(
    searchProduct,
    600
  )

  const { cursorBasedPagination, setPagination, setPageBasedPagination } =
    usePagination()

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      skip: 0,
    }))
  }, [debouncedProduct, setPagination])

  const productsQuery = useFindProductLcas({
    skip: cursorBasedPagination.skip,
    take: cursorBasedPagination.take,
    searchProduct: debouncedProduct,
    filters: {
      status: statusFilter ?? undefined,
    },
  })

  return (
    <Stack>
      <DataFetchWrapper query={productsQuery}>
        {({ data, isFetching }) => (
          <Stack>
            <ProductsLCATable
              data={data}
              isFetching={isFetching}
              fetchDataOptions={cursorBasedPagination}
              setPagination={setPageBasedPagination}
              searchProduct={searchProduct}
              setSearchProduct={setSearchProduct}
              statusFilter={statusFilter}
              setStatusFilter={setStatusFilter}
            />
          </Stack>
        )}
      </DataFetchWrapper>
    </Stack>
  )
}

export const ProductsLCAWrapper = () => {
  return (
    <HeaderControlsProvider>
      <ProductsLCA />
    </HeaderControlsProvider>
  )
}
